// import { config, orderbook } from "@imtbl/sdk";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import detectEthereumProvider from '@metamask/detect-provider'
import { ethers } from 'ethers';
import styled from "styled-components";
import GreenIsotype from "../assets/img/GreenIsotype.png";
import { getRentedAssetDetails, completeRent } from "../context/QorbiService";
import GradientButton from "../components/GradientButton";
import LoaderModal from "../components/Modals/LoaderModal";
import ResultAssetTransfer from "../components/Modals/ResultAssetTransfer";
import SuperverseLogo from "../assets/svg/superverseLogo";
import RentConfirmationModal from "../components/Modals/RentItemMarketplace";

const StyledMarketPlaceItemDetail = styled.div`
    display: flex;    
    justify-content: space-between;
    align-items: start;
    margin: 0px;
    padding: 100px 100px 0px 100px;
    width: 100vw;

    .loading-widget {
        width: 100vw;
        height: 80vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;        

        img {
            width: 200px;
            height: 200px;
            object-fit: fill;
            margin-bottom: 10px;
        }

        p {
            margin: 0px;
            color: #FFFFFF;
            font-size: 22px;
            font-weight: 600;
            line-heignt: 23px;
        }
    }

    .item-image-container {
        flex: 1;
        aspect-ratio: 1 / 1 !important;        
        border-radius: 70px;
        background: grey;
    }

    .item-image {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 70px;
    }

    .item-details-container {
        flex: 2;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
        margin-left: 100px;

        #title-and-listing-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        #title-and-listing {
            display: flex;
            flex: 2;
            flex-direction: column;
            justify-content: space-between;
            align-items: start;
            color: #FFFFFF;
        }

        #buy-now-button {
            height: 50px;
            width: 234px;
            border-radius: 14px;
            background: linear-gradient(#38EF7D, #11998E);
            display: flex;
            justify-content: center;
            align-items: center;
            color: #FFFFFF;
        }

        #item-information-container {
            background-color: #1C1C1C;
            border-radius: 35px;
            width: 100%;
            height: 188px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: start;
            margin: 0px;
            padding: 24px;            
        }

        .information-tile {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        #attributes-container {
            width: 100%;
            display: flex;
            justify-content: start;
            align-items: start;
            flex-wrap: wrap;
        }

        .attribute-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px;
            background: #1C1C1C;
            border-radius: 24px;
            width: 214px;
            height: 106px;
        }

        .attribute-spacer {
            width: 10px;
            height: 10px;
        }

        .container-title {
            margin-top: 50px;
            margin-bottom: 35px;
            color: #FFFFFF;
            font-size: 26px;
            font-weight: 400;
            line-height: 31px;
        }

        .information-name {
            color: #FFFFFF;
        }

        #price-details {
            display: flex;
            justify-content: start;
            align-items: center;

        }

        #currency-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            border-radius: 100px;
            background: linear-gradient(#38EF7D, #11998E);
            margin-right: 10px;
        }

        #asset-name {
            font-size: 32px;
            font-family: "exo", sans-serif;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 38px;
            margin-bottom: 24px;
        }

        .asset-crypto-price {
            font-size: 26px;
            font-weight: 400;
            color: #A6A6A6;
            line-height: 31px;
            margin-right: 5px;
        }  
            
        #asset-amount {
            font-size: 26px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 31px;
            margin-right: 5px;
        }

        .attribute-container{
            display: flex;
            flex-direction: column;
            justify-content: space-betwenn;
            align-items: start;
            padding: 24px;
            margin-bottom: 5px;
            width: 214px;
            height: 106px;
        }

        .attribute-title {
            width: 100%;
            font-size: 18px;
            font-weight: 400;
            line-height: 20px;
            color: #38EF7D;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        
        .attribute-value { 
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: #FFFFFF;
        }
    }

    @media(width <= 700px){
        flex-direction: column;
        padding: 10px 10px 0px 10px;
        margin-top: 25%;

        .item-image-container {
            flex: 1;
            width: 100%;
            height: 40vh;
            border-radius: 15px;
            background: transparent;
        }

        .item-image {
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 15px;
        }

        .item-details-container {
            width: 100%;
            margin: 0px;
        }        

        #title-and-listing-container {
            flex-direction: column;
        }

        #asset-name {
            text-align: center;
        }

        #title-and-listing {
            align-items: center !important;
            margin-bottom: 24px;
        }

        #price-details {
            justify-content: center;
        }

        .container-title {
            margin-top: 10px !important;
            margin-bottom: 5px !important;
        }

        #attributes-container {
            padding-top: 10px;
            justify-content: center !important;
        }

        .attribute-container {
            width: 180px !important;
            height: 50px;
        }

        .attribute-title {
            font-size: 14px !important;
        }
    }
`;
export default function RentItemDetail() {

    const zkevmCollections = {
        "0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a": 'pet', //Pets
        "0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d": 'qorb', //Qorb
        "0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757": 'pass', //qorX
        "0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd": 'skin', //Skins
    };

    const params = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [listing, setListing] = useState(null);
    const loaderModalRef = useRef();
    const [loaderText, setLoaderText] = useState("Transferring Asset");
    const resultTransferAssetRef = useRef();
    const resultTransferAssetResultMessage = useRef('Something Went Wrong');
    const isTrasnferSuccess = useRef(false);

    useEffect(() => {
        async function loadData() {
            var item = await getRentedAssetDetails(params.contractAddress, params.tokenId);
            const collectionType = zkevmCollections[item.nftData.contractAddress.toLowerCase()];
            if (collectionType) {
                const metadataResponse = await fetch(`https://assets.qorbiworld.com/resource/${collectionType}/${item.nftData.tokenId}`);
                const result = await metadataResponse.json();
                setListing({ ...item, ...result });
            }
            setIsLoading(false);
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const rentModalRef = useRef();

    const handleOpenModal = () => {
        rentModalRef.current.open();
    };

    const handleConfirmRent = async (numberOfMatches, totalPrice) => {
        console.log(`Matches: ${numberOfMatches}, Total Price: ${totalPrice}`);
        loaderModalRef.current.open();
        let tokenAddress, chainId;
        if (listing.currency === "QORBI") {
            tokenAddress = '0x07278800fFBbB715C826E9D780FFfE7ec7001127' //Qorbi token
            chainId = '0x89';
        } else if (listing.currency === "SUPER") {
            tokenAddress = '0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55' //Super token
            chainId = '0x1';
        }
        const recipient = '0x813dB47F6D0be1eE3729b865E8b257B64EcaEA6a' //Admin Wallet
        try {
            const providerMetamask = await detectEthereumProvider();
            if (providerMetamask) {
                const accounts = await providerMetamask.request({
                    method: "eth_requestAccounts",
                })
                const provider = new ethers.providers.Web3Provider(window.ethereum);
                const network = await provider.getNetwork();
                if (network.chainId !== parseInt(chainId, 16)) {
                    isTrasnferSuccess.current = false;
                    resultTransferAssetResultMessage.current = `Incorrect Network, Switch to ${listing.currency === "QORBI" ? "Polygon" : "BNB Smart Chain"}`;
                    loaderModalRef.current.close();
                    resultTransferAssetRef.current.open();
                    return;
                }
                const signer = provider.getSigner();
                const erc20Abi = [
                    "function balanceOf(address owner) view returns (uint256)",
                    "function transfer(address to, uint256 amount) returns (bool)"
                ];
                const contract = new ethers.Contract(tokenAddress, erc20Abi, signer);
                const balance = await contract.balanceOf(accounts[0]);
                if (balance.lt(ethers.utils.parseUnits(totalPrice.toString(), 18))) {
                    isTrasnferSuccess.current = false;
                    resultTransferAssetResultMessage.current = "Insufficient Funds";
                    loaderModalRef.current.close();
                    resultTransferAssetRef.current.open();
                    return;
                }
                setLoaderText("Sending Funds");
                const tx = await contract.transfer(recipient, ethers.utils.parseUnits(totalPrice.toString(), 18));
                await tx.wait();
                setLoaderText("Wait a second...");
                const minted = await completeRent(tx.hash, listing.currency, numberOfMatches, listing.nftData.tokenId, listing.nftData.contractAddress);
                if (minted?.result === "Item successfully rented.") {
                    window.location.href = '/my-assets';
                }
            }

        } catch (error) {
            isTrasnferSuccess.current = false;
            resultTransferAssetResultMessage.current = "Purchase Failed, contact support";
            loaderModalRef.current.close();
            resultTransferAssetRef.current.open();
        }

    }

    function shortenAddress(address) {
        if (address) {

            if (address.length <= 22) return address;
            return `${address.slice(0, 18)}...${address.slice(-4)}`;
        } else {
            return 'No Wallet Address Found'
        }
    }

    return (
        <>
            <ResultAssetTransfer
                ref={resultTransferAssetRef}
                isSuccess={isTrasnferSuccess.current}
                errorMessage={resultTransferAssetResultMessage.current}
            />
            <LoaderModal ref={loaderModalRef} title={"Transferring Asset"} subtitle={loaderText}></LoaderModal>
            <StyledMarketPlaceItemDetail>
                {
                    isLoading ?
                        <div className="loading-widget">
                            <img alt='Green Isotype' src={GreenIsotype} />
                            <p>Loading Data...</p>
                        </div>
                        :
                        <>
                            <div className="item-image-container">
                                <img alt="NFT" className="item-image" src={listing.image}></img>
                            </div>
                            <RentConfirmationModal
                                ref={rentModalRef}
                                matchPrice={100}
                                onConfirm={handleConfirmRent}
                            />
                            <div className="item-details-container">
                                <div id="title-and-listing-container">
                                    <div id="title-and-listing">
                                        <div id="asset-name">{listing.name}</div>
                                        <div id="price-details">
                                            <div id="currency-icon">
                                                {
                                                    (listing.currency ?? 'QORBI') === "QORBI" ?
                                                        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.507 13.0089C15.3319 11.8301 15.8177 10.4476 15.9114 9.0119C16.0051 7.5762 15.7032 6.14229 15.0385 4.86627C14.3738 3.59024 13.3719 2.52099 12.1417 1.77489C10.9115 1.0288 9.50018 0.634449 8.06142 0.634769C7.70573 0.634432 7.35043 0.658548 6.99805 0.706947V2.41868C7.40152 2.3368 7.81212 2.29512 8.22383 2.29424C9.48644 2.2932 10.7189 2.68019 11.7543 3.40279C12.7897 4.1254 13.578 5.14872 14.0126 6.33421C14.4471 7.5197 14.5069 8.81008 14.1837 10.0307C13.8606 11.2512 13.1702 12.343 12.206 13.1582L13.0852 14.0486L13.3509 14.3181L15.1684 16.1611H17.8023L14.5045 13.007L14.507 13.0089Z" fill="white" />
                                                            <path d="M11.4964 13.682C10.1674 14.5266 8.56547 14.8301 7.01965 14.5303C5.47383 14.2305 4.10151 13.3501 3.18459 12.07C2.26768 10.7899 1.87579 9.20727 2.08944 7.64721C2.30308 6.08715 3.10604 4.66813 4.33336 3.68166L4.35327 8.52131C4.35327 9.53736 4.75689 10.5118 5.47535 11.2303C6.19381 11.9487 7.16824 12.3523 8.18429 12.3523C8.69144 12.3571 9.19449 12.2611 9.66427 12.07C10.134 11.8788 10.5612 11.5963 10.921 11.2389C11.2807 10.8814 11.5659 10.456 11.7601 9.98748C11.9542 9.51894 12.0534 9.01651 12.0519 8.50934C12.0503 8.00217 11.9481 7.50035 11.7512 7.03298C11.5543 6.56561 11.2665 6.14198 10.9046 5.78667C10.5427 5.43136 10.1138 5.15143 9.64291 4.96312C9.172 4.77481 8.66838 4.68186 8.16127 4.68966C7.75535 4.6915 7.3523 4.75787 6.96723 4.88628V6.76851C7.35002 6.4806 7.81864 6.33005 8.29749 6.34113C8.77634 6.35221 9.23749 6.52428 9.60656 6.82958C9.97563 7.13488 10.2311 7.5556 10.3317 8.02389C10.4324 8.49217 10.3723 8.98071 10.1613 9.41068C9.95023 9.84066 9.60049 10.187 9.16847 10.3938C8.73645 10.6007 8.24736 10.6559 7.78008 10.5507C7.3128 10.4455 6.89459 10.186 6.59291 9.81393C6.29123 9.4419 6.12367 8.97909 6.11727 8.50015L6.10296 5.30442L6.11727 2.66184V0.87793C4.26019 1.3515 2.6399 2.48682 1.56075 4.07064C0.481606 5.65445 0.017853 7.57779 0.256602 9.47937C0.495351 11.381 1.42017 13.13 2.85736 14.3978C4.29454 15.6657 6.1452 16.3653 8.06171 16.365C8.15069 16.365 8.23967 16.365 8.32678 16.3601V16.365L14.0232 16.1628L12.6543 14.8854L11.4958 13.6826L11.4964 13.682Z" fill="white" />
                                                        </svg>
                                                        : listing.currency === "SUPER" ?
                                                            <SuperverseLogo></SuperverseLogo>
                                                            :
                                                            <img src='https://img.cryptorank.io/coins/fate%20token1635248931540.png' alt="Fate Icon" style={{ width: 20, height: 20, objectFit: "contain" }} />
                                                }
                                            </div>
                                            <div className="asset-crypto-price">{parseFloat(listing.matchPrice).toFixed(2)}</div>
                                            <div className="asset-crypto-price">{listing.currency} per Match</div>
                                        </div>
                                    </div>
                                    {listing.pendingOwnerMatches < 1 &&<GradientButton onTap={handleOpenModal} text={'Rent Now'}></GradientButton>}
                                </div>
                                <div className="container-title">Item Information</div>
                                <div id="item-information-container">
                                    <div className="information-tile"><p className="information-name">ID</p><p>{params.tokenId}</p></div>
                                    <div className="information-tile"><p className="information-name">Contract Address</p><p>{shortenAddress(params.contractAddress)}</p></div>
                                </div>
                                <div className="container-title">Attributes ({listing.attributes.length})</div>
                                <div id="attributes-container">
                                    {
                                        listing.attributes.map((attribute, index) => {
                                            return (
                                                <div key={index}>
                                                    <div className="attribute-container">
                                                        <div className="attribute-title">{attribute.trait_type.toString().toUpperCase()}</div>
                                                        <div className="attribute-value">{attribute.value}</div>
                                                    </div>
                                                    <div className="attribute-spacer"></div>
                                                </div>

                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </>
                }
            </StyledMarketPlaceItemDetail>
        </>
    );
}